/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type WorksheetAuth_viewer = {
    readonly user: {
        readonly id: string;
    } | null;
    readonly " $refType": "WorksheetAuth_viewer";
};
export type WorksheetAuth_viewer$data = WorksheetAuth_viewer;
export type WorksheetAuth_viewer$key = {
    readonly " $data"?: WorksheetAuth_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"WorksheetAuth_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "WorksheetAuth_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'd57eecac5abeda39979b7232128f5068';
export default node;
